import JSX from "../../helpers/react.js";
import {LoadingSpinner} from "../elements/index.js";
import RefObject = JSX.RefObject;
import {handleFetchError, YummyServerError} from "../../helpers/functions.js";
import {ServerApi} from "../../api.js";
import {DevApp} from "./DevApp.js";
import { AddNewAppDialog } from "./AddNewAppDialog.js";


function AddAppIcon() {
    return (
        <div className="add-my-app">
            <div onClick={addNewApp}><i className="fa fa-plus"></i></div>
        </div>
    )
}
function addNewApp(){
    document.body.appendChild(<AddNewAppDialog appID={0}/>)
}

export function AppsAllContent() {
    const data: RefObject<HTMLDivElement> = {}
    const loading: RefObject<HTMLDivElement> = {}
    setTimeout(() => loadData(data, loading));

    return (
        <>
            <AddAppIcon/>
            <div className="data" ref={data}>
            </div>
            <div className="loading" ref={loading}>

            </div>
        </>
    )
}

async function loadData(data: RefObject<HTMLDivElement>, loadingSpinner: RefObject<HTMLDivElement>) {
    const offset = +(data.value!.dataset['offset'] || 0)
    try {
        loadingSpinner.value!.innerText = '';
        loadingSpinner.value!.appendChild(<LoadingSpinner large={true}/>)

        const response = await ServerApi.apps.getApps({offset, limit: 10});
        for (const i of response) {
            data.value!.appendChild(<DevApp app={i}/>)
        }

        data.value!.dataset['offset'] = (offset + response.length) + "";
        loadingSpinner.value!.innerText = '';
        if (response.length >= 10)
            loadingSpinner.value!.appendChild(<LoadMore callback={() => loadData(data, loadingSpinner)}/>)

    } catch (e) {
        loadingSpinner.value!.innerText = '';
        loadingSpinner.value!.appendChild(<Error retry={() => loadData(data, loadingSpinner)} error={e}/>)
        handleFetchError(e);
    }
}

function Error({retry, error}: { retry: () => any, error: any }) {
    const msg = (error instanceof YummyServerError) ? error.title : "";
    return (
        <div className="center">
            Произошла неизвестная ошибка{msg && " (" + msg + ")"}. <br/>
            <button className="main-button bordered" onClick={retry}>Попробовать ещё раз</button>
        </div>
    )
}

function LoadMore({callback}: { callback: () => any }) {
    return (
        <div className="center">
            <button className="main-button load-more" onClick={callback}>Показать ещё</button>
        </div>
    )
}